import { DEVICE_ENDPOINTS, DeviceLinkRequest, LinkedDevice } from '@iws/backoffice-api'

import { httpRequest } from '@/clients/http'

/** Connects this till with the code from Settings → POS → Connect (POS.md §12.9.2, O2); the tenant comes from the host. */
export const DeviceModel = {
  link: (body: DeviceLinkRequest) =>
    httpRequest<{ result: LinkedDevice }>({
      method: 'post',
      url: DEVICE_ENDPOINTS.link,
      body,
    }),
}
